import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { AdCarousel } from "@/components/landing/AdCarousel";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { ProcessStrip } from "@/components/landing/ProcessStrip";
import { RetailSection } from "@/components/landing/RetailSection";
import { CtaSection } from "@/components/landing/CtaSection";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <main className="relative min-h-screen bg-[#eefbf7] text-slate-900">
            <Nav />
            <Hero />
            <AdCarousel />
            <HowItWorks />
            <ProcessStrip />
            <RetailSection />
            <CtaSection />
            <Footer />
        </main>
    );
}
